module.exports = __webpack_public_path__ + "img/soft_g.a8406af4.png";